module.exports = __webpack_public_path__ + "img/logo_verde.c0690a6a.png";